// 坦克大战 3D - 游戏配置
// 所有数值集中管理，方便调试与调整

// ==================== 竞技场 ====================
export const ARENA_SIZE = 60; // 竞技场边长 (units)
export const ARENA_HALF = ARENA_SIZE / 2;
export const ARENA_WALL_HEIGHT = 3;
export const ARENA_WALL_THICKNESS = 1;

// ==================== 坦克 ====================
export const TANK_BODY_WIDTH = 2.4;
export const TANK_BODY_HEIGHT = 1.2;
export const TANK_BODY_DEPTH = 3.2;
export const TANK_TURRET_RADIUS = 0.6;
export const TANK_TURRET_HEIGHT = 0.5;
export const TANK_BARREL_LENGTH = 2.5;
export const TANK_BARREL_RADIUS = 0.22;
export const TANK_Y_POS = TANK_BODY_HEIGHT / 2; // 坦克底部贴地

// ==================== 玩家 ====================
export const PLAYER_SPEED_FWD = 8; // 前进速度 (units/s)
export const PLAYER_SPEED_BACK = 5; // 后退速度 (units/s)
export const PLAYER_TURN_SPEED = 120; // 车体旋转速度 (°/s)
export const TURRET_TURN_SPEED = 150; // 炮塔旋转速度 (°/s)
export const PLAYER_HP = 100;
export const PLAYER_LIVES = 3;

// ==================== 炮弹 ====================
export const BULLET_SPEED = 30; // 炮弹飞行速度
export const BULLET_RADIUS = 0.25;
export const BULLET_DAMAGE = 35;
export const BULLET_LIFETIME = 3; // 炮弹存在时间(秒)
export const FIRE_COOLDOWN = 0.8; // 射击冷却(秒)

// ==================== 敌人 ====================
export const ENEMY_BASE_HP = 80;
export const ENEMY_BASE_SPEED = 4;
export const ENEMY_BASE_FIRE_RATE = 1.8; // 射击间隔(秒)
export const ENEMY_DETECT_RANGE = 20; // 侦测玩家范围
export const ENEMY_PATROL_RANGE = 12; // 巡逻范围

// ==================== 掩体 ====================
export const OBSTACLE_MIN_SIZE = 2;
export const OBSTACLE_MAX_SIZE = 6;
export const OBSTACLE_MIN_HEIGHT = 1.5;
export const OBSTACLE_MAX_HEIGHT = 3.5;
export const OBSTACLE_COUNT = 10;

// ==================== 道具 ====================
export const HP_PICKUP_AMOUNT = 50;
export const HP_PICKUP_COUNT_PER_WAVE = 2;
export const PICKUP_RADIUS = 0.6;
export const PICKUP_Y = 0.8;

// ==================== 波次 ====================
export const WAVE_BASE_ENEMIES = 2; // 第1波敌人数量
export const WAVE_ENEMY_INCREMENT = 1; // 每波增加敌人数量
export const WAVE_SPEED_SCALE = 0.15; // 每波敌人速度增加比例
export const WAVE_HP_SCALE = 0.2; // 每波敌人血量增加比例
export const WAVE_FIRE_RATE_SCALE = 0.1; // 每波射击频率增加比例
export const WAVE_TRANSITION_TIME = 3; // 波间过渡时间(秒)

// ==================== 摄像机 ====================
export const CAMERA_DISTANCE = 14;
export const CAMERA_HEIGHT = 9;
export const CAMERA_LAG = 0.12;
export const CAMERA_LOOK_AHEAD = 4;

// ==================== 颜色 ====================
export const COLOR_PLAYER_BODY = '#4a9e3f';
export const COLOR_PLAYER_TURRET = '#3a7e2f';
export const COLOR_ENEMY_BODY = '#c0392b';
export const COLOR_ENEMY_TURRET = '#96281b';
export const COLOR_OBSTACLE = '#6c7a89';
export const COLOR_GROUND = '#3d4a3a';
export const COLOR_WALL = '#5a6a5a';
export const COLOR_BULLET_PLAYER = '#f5e642';
export const COLOR_BULLET_ENEMY = '#e74c3c';
export const COLOR_PICKUP_HP = '#2ecc71';
export const COLOR_SKY = '#1a1a2e';
